export default "__VITE_ASSET__CxED_Ti6__"